module.exports = __webpack_public_path__ + "static/media/Serial Position Effect - vlad-tchompalov-wt5Y8VY_0bA-unsplash.b25f669f.jpg";